import script from "./PreSportsHighlights.vue?vue&type=script&setup=true&lang=js"
export * from "./PreSportsHighlights.vue?vue&type=script&setup=true&lang=js"

import "./PreSportsHighlights.vue?vue&type=style&index=0&id=578298a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-578298a0"]])

export default __exports__